import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ProgressSpinnerComponent } from './components/progress-spinner/progress-spinner.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { EmptysateComponent } from './components/emptysate/emptysate.component';
import SearchFilterWebappsPipe from './pipes/search-filter-webapps.pipe';
import { HighlightPipe } from './pipes/highlight.pipe';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatListModule } from '@angular/material/list';
import { AppSettingsFormComponent } from './components/app-settings-form/app-settings-form.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { KeyInputAppSettingsFormComponent } from './components/key-input-app-settings-form/key-input-app-settings-form.component';
import { NavbarComponent } from './components/navbar/navbar.component';


@NgModule({
  declarations: [
    NavbarComponent,
    ProgressSpinnerComponent,
    EmptysateComponent,
    SearchFilterWebappsPipe,
    HighlightPipe,
    AppSettingsFormComponent,
    KeyInputAppSettingsFormComponent
  ],
  imports: [    
    MatIconModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatListModule,
    NgSelectModule,
    CommonModule,
    RouterModule,
    MatProgressSpinnerModule   
  ],
  exports: [
    NavbarComponent,
    ProgressSpinnerComponent,
    EmptysateComponent,
    SearchFilterWebappsPipe,
    HighlightPipe,
    AppSettingsFormComponent,
    KeyInputAppSettingsFormComponent  
  ]
})
export class SharedModule { }
